import cx from "classnames";
import { ReactNode } from "react";

import { Icon } from "@/atoms/icon/Icon";

type IconType = Parameters<typeof Icon>[0]["svg"];

export interface OnboardingHeaderProps {
  icon?: IconType;
  title: string | ReactNode;
  subtitle?: string | ReactNode;
  align?: "left" | "center";
  className?: string;
  titleClassName?: string;
  subtitleClassName?: string;
}

export const OnboardingHeader = ({
  icon,
  title,
  subtitle,
  align = "center",
  className = "",
  titleClassName = "",
  subtitleClassName = "",
}: OnboardingHeaderProps) => {
  const alignment = align === "center" ? "items-center text-center" : "items-start text-left";

  return (
    <div className={`flex w-full flex-col gap-2 ${alignment} ${className}`}>
      {icon ? <Icon svg={icon} color="brandColor" size="xlarge" /> : null}
      <div
        className={cx(
          "font-serif text-[24px] font-normal italic leading-8 tracking-[0.48px] text-primary",
          titleClassName,
        )}
      >
        {typeof title === "string" ? <h1 className="whitespace-pre-line">{title}</h1> : title}
      </div>
      {subtitle ? (
        <div
          className={cx(
            "text-center font-sans text-body1 font-medium leading-[18px] text-secondary",
            subtitleClassName,
          )}
          style={{ fontVariationSettings: "'opsz' 14" }}
        >
          {typeof subtitle === "string" ? <p>{subtitle}</p> : subtitle}
        </div>
      ) : null}
    </div>
  );
};

export default OnboardingHeader;
